export const shopData = [
    {"title": "d50 The shop sells...", "id":"d50theshopsells_shops", "roll":[
        "Weapons",
        "Armor",
        "Magical items",
        "Fresh food",
        "Cured food",
        "Livestock",
        "Slaves",
        "Services",
        "Mostly junk",
        "Artwork",
        "Jewellery",
        "Gems and Ores",
        "Mining tools",
        "Household goods",
        "Farming tools",
        "Animal feed",
        "Crafting tools",
        "Ales and Liqueur",
        "Items of interest from a previous generation",
        "Items of interest from a far-away land",
        "Clothing",
        "Gnomish Gadgets",
        "Potions",
        "Poisons",
        "Alchemical Supplies",
        "Magical Supplies",
        "Musical instruments",
        "Fabrics",
        "A little bit of everything",
        "Spices",
        "Hunting Tools",
        "Herbs",
        "Remedies and tonics",
        "Books",
        "Dolls",
        "Toys",
        "Exotic Animals",
        "Furs and Pelts",
        "Illicit Goods",
        "Cheeses",
        "Meats",
        "Pack animals",
        "Building supplies",
        "Fruits and vegetables",
        "Supplies for a local guild",
        "Leather goods",
        "Good crafted from rare metals",
        "Beauty and hygiene supplies",
        "Magical creatures",
        "Wagon wheels",   ]},
    {"title": "d10 The shop's type is...", "id":"d10theshopstypeis_shops", "roll":[
        "A building in a merchant district",
        "Attached to the merchant's home",
        "A wagon pulled by a horse or ox team",
        "Under a tent",
        "In an open bazaar on a rug",
        "In a stall in a bazaar",
        "In the back room of another shop",
        "A merchant caravan",
        "In a place only accessibly by magic",
        "A franchise. The shop can be found in multiple places",   ]},
    {"title": "d12 The shop is owned by...", "id":"d12theshopisownedby_shops", "roll":[
        "A beady-eyed accountant",
        "A guild leader",
        "A noble",
        "An obsessive-compulsive gnome",
        "A greedy dwarf",
        "A former soldier",
        "A farmer's wife",
        "A snobby high-elf",
        "A forgetful halfling",
        "An oppressive brute",
        "An old crone",
        "A lazy half-orc",   ]},
    {"title": "d6 The shop's condition is...", "id":"d6theshopsconditionis_shops", "roll":[
        "Brand new. Everything has a place, and is in its place",
        "Well maintained. It is cleaned regularly",
        "Average. A little dusty",
        "Unkempt. Bugs and rodents scurry away from your footsteps",
        "Dark. There is no natural light. Only a candle or two light the shop",
        "Decrepit. The building should be condemned",   ]},
    {"title": "d6 The condition of the merchandise is...", "id":"d6theconditionofthemerchandiseis_shops", "roll":[
        "Pristine. Kept in the best possible condition",
        "Cleaned regularly",
        "Mixed. Some items look new, while some look like they have been there a long time",
        "Dusty and dirty",
        "Falling apart",
        "Ancient",   ]},
    {"title": "d6 The shop gets its supplies from...", "id":"d6theshopgetsitssuppliesfrom_shops", "roll":[
        "They are crafted or attained by the merchant himself",
        "They are crafted or attained by the merchant's apprentices",
        "The merchant's business partner",
        "They are crafted elsewhere in bulk, and sold in the shop",
        "They are purchased from other people in town and resold",
        "No one knows, and no one asks",   ]},
    {"title": "d8 The items are priced...", "id":"d8theitemsarepriced_shops", "roll":[
        "Fairly",
        "Below value",
        "Above value",
        "Exorbitantly",
        "Everything is for barter",
        "\"Other\" means of payment are encouraged",
        "Based on the merchant's mood",
        "Based on how much the merchant thinks the customer needs it.",   ]},
    {"title": "d5 The shop's size is...", "id":"d5theshopssizeis_shops", "roll":[
        "Giant. Multiple rooms",
        "Large. One big room",
        "Average. One room big enough to hold what is needed",
        "Small. The room feels cluttered",
        "Tiny. The merchant practically operates out of a pack",   ]},
    {"title": "d4 How busy is the shop...", "id":"d4howbusyistheshop_shops", "roll":[
        "It's one of the most popular places to visit",
        "A few people mill in and out of the shop",
        "Not very busy. You are the only people there",
        "It rarely sees a customer",   ]},
    {"title": "d50 Something interesting you find...", "id":"d50somethinginterestingyoufind_shops", "roll":[
        "The shopkeeper lives in a room attached to the shop",
        "There is a secret room in the back to sell illicit wares",
        "The shopkeeper does not seem to belong there",
        "One of the items does not seem to belong there",
        "A bell rings every time someone enters the shop",
        "The shopkeeper is unusually friendly",
        "The shopkeeper does not seem to want any business",
        "Some items are oddly magical (or non-magical)",
        "You feel an unseen presence watching you",
        "Magical barriers prevent people from handling the merchandise",
        "A goblin is handling some of the wares",
        "A ogre is leashed to one of the walls",
        "A couple dogs keep an eye on you, while chewing on a bone",
        "A cat follows you around the shop",
        "A goat seems to be keeping guard outside the shop",
        "A rats nest is forming in a secluded corner",
        "A talking bird insists on yelling obscenities at you",
        "Many items are being packed for sale",
        "A new shipment has just arrived, and is being stocked",
        "You hear noises from the roof or room above the shop",
        "The floor is cracked",
        "The merchant is cleaning up an item that was ruined on the shop floor",
        "The shopkeeper is arguing with an employee",
        "A monkey follows you and tries to hand merchandise to you",
        "Footprints lead directly into a wall",
        "A raven tries to steal items from your bag",
        "The merchant's young children are trying unsuccessfully at a hard sale",
        "The merchant does not speak common",
        "Items change when you're not looking",
        "Music is playing throughout the shop",
        "The merchant can tell a story behind everything he sells",
        "Some of the items appear stolen",
        "The shop is only open at night",
        "The shop is closed for the day",
        "An unusual item is for sale with a dark backstory",
        "A couple of thugs are holding up the merchant",
        "One of the customers is trying to shoplift",
        "The shop has a strong odor of mildew",
        "The shop is owned by a friend or former party member",
        "A ghost is browsing the merchandise",
        "The shopkeeper is fast asleep",
        "The shopkeeper has a pungent and offensive smell",
        "The shopkeeper is a forceful salesman",
        "A legendary weapon is on display, but not for sale",
        "Murals line the walls",
        "The merchant insists he is from an ancient line of powerful merchants",
        "The merchant dresses much better than expected",
        "The merchant looks like a beggar",
        "Constables or the local guard are interviewing everyone in the shop",
        "The shopkeeper just died",   ]},
        
]